<div *ngIf="!dataAvailable">Loading</div>
<div *ngIf="dataAvailable" class="outer-container">

    <div class="sticky-btn">
        <div class="marketing" (click)="navigateToMarketing()">Click Here To Unlock Your Learning Potential</div>
    </div>

    <div fxLayout="column">
        <div class="sub-title">{{report.CourseName}} Diagnostic Exam Results</div>

        <div class="therm-container" >

            <div class="therm-bar" fxLayout="column">

                <div
                class="therm-top"
                [class.therm-top-white]="report.AOELessonCount + report.AOILessonCount < report.TotalLessons"
                [class.therm-top-blue]="report.AOELessonCount + report.AOILessonCount == report.TotalLessons">
                </div>

                <div
                class="totalMinusCount"
                [style.height]="totalMinusCountPercentage">
                </div>

                <div
                class="aoe-count"
                [style.height]="aoeCountPercentage">
                    <div
                    class="therm-suggested-line">
                            <div class="arrow suggested-arrow">
                                <div class="left-line"></div>
                                <div class="left-point"></div>
                              </div>
                        <div class="therm-suggested-text">
                            Your Results Suggested <br> {{report.AOELessonCount + report.AOILessonCount}} Lessons
                        </div>
                    </div>
                </div>

                <div
                class="aoi-count"
                [style.height]="aoiCountPercentage">
                </div>

                <div
                class="therm-bot"
                [class.therm-bot-blue]="report.AOELessonCount > 0 || report.AOILessonCount > 0"
                [class.therm-bot-white]="report.AOELessonCount == 0 && report.AOILessonCount == 0">
                </div>

            </div>

            <div
            class="therm-overlay"
            fxLayout="column">

                <div
                class="therm-premium"
                [style.height]="report.TotalLessons > 25 ? ((report.TotalLessons - 15)/report.TotalLessons)*100 + '%' : '100%'">
                    <div class="arrow">
                        <div class="right-line"></div>
                        <div class="right-point"></div>
                    </div>
                    <div class="therm-text-premium">
                        Premium 
                        <br> 
                        {{report.TotalLessons}} Lessons
                        <br>
                        <div class="therm-text-premium-sub">
                            Access to all {{report.TotalLessons}} lessons{{report.AOILessonCount + report.AOELessonCount - 15 > 0 ? ', which includes an additional ' + (report.AOILessonCount + report.AOELessonCount - 15) + ' suggested lessons' : ''}}.
                        </div>
                    </div>
                </div>

                <!-- <hr class="overlay-line">
                 -->

                <div
                class="therm-basic"
                *ngIf="report.TotalLessons > 25"
                [style.height]="(15/report.TotalLessons)*100 + '%'">
                    <div class="arrow">
                        <div class="right-line"></div>
                        <div class="right-point"></div>
                    </div>
                    <div class="therm-text-basic"
                    >Basic <br> 15 Lessons</div>
                </div>

            </div>

        </div>

    </div>

    <div class="container">

        <div>
            <span class="area-title">Areas for Improvement</span>
            <div class="top-text pad-5">

                The Standards listed below identify gaps of achievement. Under each Standard is a list of lessons
                suggested to strengthen those gaps.
            </div>


            <!-- <div class="pad-5">
                <i class="fas fa-book-open" matTooltip="Lesson"></i> = Lesson
            </div> -->

            <hr>

            <div class="non-prof-std-lessons pad-5">
                <div fxLayout="row wrap">
                    <div class="std-card" *ngFor="let aoi of areasOfImprovement" fxLayout="column">

                        <div class="std-moreinfo aoi">
                            <div class="std-card-title">
                                Learning Standard {{aoi.Standard.StandardCode}}
                            </div>

                            <div
                            class="more-info"
                            fxLayout="row"
                            fxLayoutAlign="center"
                            (click)="showStandardDescriptionPopUp(aoi.Standard.StandardCode, aoi.Standard.StandardDescription)">
                                more info
                            </div>

                        </div>


                        <!-- <div class="sub-group-description>"></div> -->

                        <div class="lessons-container">
                            <!-- <div>Lessons</div> -->
                            <div fxLayout="column">
                                <!-- Lessons: -->
                                <ul *ngFor="let lesson of aoi.Lessons">
                                    <i class="fas fa-book-open" matTooltip="Lesson"></i> {{lesson.LessonName}}
                                </ul>
                            </div>
                        </div>

                    </div>
                </div>

            </div>

        </div>

        <div class=" mt-30">
            <span class="area-title">Areas for Exploration</span>
            <br>
            <div class="top-text pad-5">
                These Standards were not tested during the free diagnostic. However, they will be tested for on the Basic or Premium Pre-Course Diagnostic.
            </div>

            <hr>
            <div class="not-tested-std-lessons pad-5">

                <div fxLayout="row wrap">
                    <div class="std-card" *ngFor="let aoe of areasOfExploration" fxLayout="column">

                        <div class="std-moreinfo aoe">
                            <div class="std-card-title">
                                Learning Standard {{aoe.Standard.StandardCode}}
                            </div>

                            <div
                            class="more-info"
                            fxLayout="row"
                            fxLayoutAlign="center"
                            (click)="showStandardDescriptionPopUp(aoe.Standard.StandardCode, aoe.Standard.StandardDescription)">
                                more info
                            </div>
                        </div>


                        <!-- <div class="sub-group-description>"></div> -->

                        <div class="lessons-container">
                            <!-- <div>Lessons</div> -->
                            <div fxLayout="column">
                                <ul *ngFor="let lesson of aoe.Lessons">
                                    <i class="fas fa-book-open" matTooltip="Lesson"></i> {{lesson.LessonName}}
                                </ul>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>


        <div class=" mt-30">
            <span class="area-title">Areas of Achievement</span>
            <br>
            <div class="top-text pad-5">
                You are already proficient in these Standards.
            </div>
            <hr>
            <div class="prof-stds pad-5">


                <div fxLayout="row wrap">
                    <div class="std-card" *ngFor="let profStd of report.ProficientStandards" fxLayout="column">

                        <div class="std-moreinfo profStd">
                            <div class="std-card-title">
                                Learning Standard {{profStd.StandardCode}}
                            </div>

                            <div
                            class="more-info"
                            fxLayout="row"
                            fxLayoutAlign="center"
                            (click)="showStandardDescriptionPopUp(profStd.StandardCode, profStd.StandardDescription)">
                                more info
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>



    </div>


</div>